import { render, staticRenderFns } from "./SubgroupAddHostForm.vue?vue&type=template&id=6ec52452&"
import script from "./SubgroupAddHostForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupAddHostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports